import type { CoachChatConfig } from 'bundles/unified-common/providers/CoachStateProvider';
import useCourseContextConfig from 'bundles/unified-description-page-common/components/coach/useCourseContextConfig';
import useSpecializationContextConfig from 'bundles/unified-description-page-common/components/coach/useSpecializationContextConfig';

type UseXdpContextConfigProps = {
  coachModeId: string;
  coachActionId: string;
};

const useXdpContextConfig = (props: UseXdpContextConfigProps): CoachChatConfig | undefined => {
  const specialization = useSpecializationContextConfig(props);
  const course = useCourseContextConfig(props);
  return specialization ?? course;
};

export default useXdpContextConfig;
